import { FC } from "react";

import {
  RideGeoProdMaxShiftGapErrorTypes,
  RideShiftTimeAlignmentErrorTypes,
  RideSoftValidationErrorType,
} from "@ryde/shared";

import {
  RideValidationSoftErrorGeoprodMaxShiftGap,
  RideValidationSoftErrorShiftTimeAlignment,
} from "../components";
import { IRideSoftValidationErrorListProps } from "../models";
import { RideSoftValidationErrorItem } from "./ride-soft-validation.error-item";

export const RideSoftValidationErrorList: FC<
  IRideSoftValidationErrorListProps
> = ({ validationErrors }) => {
  const geoProdMaxShiftGapArrivalErrorAccumulator = validationErrors.filter(
    error =>
      error.type === RideSoftValidationErrorType.GeoProdMaxShiftGapArrival,
  );
  const geoProdMaxShiftGapDepartureErrorAccumulator = validationErrors.filter(
    error =>
      error.type === RideSoftValidationErrorType.GeoProdMaxShiftGapDeparture,
  );

  const shiftTimeAlignmentPickupTooEarlyErrors = validationErrors.filter(
    error =>
      error.type ===
      RideSoftValidationErrorType.ShiftTimeAlignmentPickupTooEarly,
  );
  const shiftTimeAlignmentPickupTooLateErrors = validationErrors.filter(
    error =>
      error.type ===
      RideSoftValidationErrorType.ShiftTimeAlignmentPickupTooLate,
  );
  const shiftTimeAlignmentDropoffTooEarlyErrors = validationErrors.filter(
    error =>
      error.type ===
      RideSoftValidationErrorType.ShiftTimeAlignmentDropoffTooEarly,
  );
  const shiftTimeAlignmentDropoffTooLateErrors = validationErrors.filter(
    error =>
      error.type ===
      RideSoftValidationErrorType.ShiftTimeAlignmentDropoffTooLate,
  );
  const otherSoftValidateErrors = validationErrors.filter(
    error =>
      !RideGeoProdMaxShiftGapErrorTypes.has(error.type) &&
      !RideShiftTimeAlignmentErrorTypes.has(error.type),
  );

  return (
    <>
      {Boolean(geoProdMaxShiftGapArrivalErrorAccumulator.length) && (
        <RideValidationSoftErrorGeoprodMaxShiftGap
          errorType={RideSoftValidationErrorType.GeoProdMaxShiftGapArrival}
          validationErrors={geoProdMaxShiftGapArrivalErrorAccumulator}
        />
      )}
      {Boolean(geoProdMaxShiftGapDepartureErrorAccumulator.length) && (
        <RideValidationSoftErrorGeoprodMaxShiftGap
          errorType={RideSoftValidationErrorType.GeoProdMaxShiftGapDeparture}
          validationErrors={geoProdMaxShiftGapDepartureErrorAccumulator}
        />
      )}
      {shiftTimeAlignmentPickupTooEarlyErrors.map((error, index) => (
        <RideValidationSoftErrorShiftTimeAlignment
          key={`pickup-too-early-${index}`}
          error={error}
        />
      ))}
      {shiftTimeAlignmentPickupTooLateErrors.map((error, index) => (
        <RideValidationSoftErrorShiftTimeAlignment
          key={`pickup-too-late-${index}`}
          error={error}
        />
      ))}
      {shiftTimeAlignmentDropoffTooEarlyErrors.map((error, index) => (
        <RideValidationSoftErrorShiftTimeAlignment
          key={`dropoff-too-early-${index}`}
          error={error}
        />
      ))}
      {shiftTimeAlignmentDropoffTooLateErrors.map((error, index) => (
        <RideValidationSoftErrorShiftTimeAlignment
          key={`dropoff-too-late-${index}`}
          error={error}
        />
      ))}
      {otherSoftValidateErrors.map((error, index) => (
        <RideSoftValidationErrorItem key={index} error={error} />
      ))}
    </>
  );
};
